(function(angular, module) {var SearchNode, TagList, TagPickerController, TagPickerTreeService, clamp, defineParent, tagGroupList, tagPickerDirective, trueMod,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  slice = [].slice,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

clamp = function(val, min, max) {
  return Math.max(min, Math.min(max, val));
};

trueMod = function(n, m) {
  return ((n % m) + m) % m;
};

TagPickerController = (function() {
  var KEYS;

  KEYS = {
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    LEFT: 37,
    ENTER: 13,
    ESC: 27
  };


  /* @ngInject */

  function TagPickerController($scope, $http, $q, $element, ApiUrl, TagPickerTree, $analytics) {
    this.keyPress = bind(this.keyPress, this);
    this.keyUp = bind(this.keyUp, this);
    this.rebuildTagMap = bind(this.rebuildTagMap, this);
    this.tagSelected = bind(this.tagSelected, this);
    this.pickTag = bind(this.pickTag, this);
    this.nodeChange = bind(this.nodeChange, this);
    var root, skip;
    this.http = $http;
    this.scope = $scope;
    this.q = $q;
    this.analytics = $analytics;
    root = $scope.root ? $scope.root.split('/') : [];
    skip = $scope.skip ? $scope.skip.split(',') : [];
    this.tree = new TagPickerTree(root, this.scope.programId || void 0, skip);
    this.tree.onPickTag(this.pickTag);
    this.tree.onNodeChange(this.nodeChange);
    this.tags = this.tags || [];
    this.tagMap = {};
    this.searchBox = $element[0].querySelector('input.search');
    this.focuser = $element[0].querySelector('input.focuser');
    this.content = $element[0].querySelector('.content');
    this._activeIndex = 0;
    this.searchModelOptions = {
      updateOn: 'default blur',
      debounce: {
        "default": 300,
        blur: 0
      }
    };
    this.scope.$watchCollection(((function(_this) {
      return function() {
        return _this.tags;
      };
    })(this)), this.rebuildTagMap);
  }

  Object.defineProperties(TagPickerController.prototype, {
    atRoot: {
      get: function() {
        return this.root === this.current;
      }
    },
    root: {
      get: function() {
        return this.tree.rootNode;
      }
    },
    current: {
      get: function() {
        return this.tree.currentNode;
      }
    },
    activeItem: {
      get: function() {
        return this.nodeItems[this.activeIndex];
      }
    },
    activeIndex: {
      get: function() {
        return this._activeIndex;
      },
      set: function(value) {
        this._activeIndex = trueMod(value, this.nodeItems.length);
        this.indexChanged();
      }
    }
  });

  TagPickerController.prototype.track = function(name, label) {
    return this.analytics.eventTrack(name, {
      category: 'Tag Picker',
      label: label
    });
  };

  TagPickerController.prototype.tagClass = function(tag) {
    var has;
    has = this.tagSelected(tag);
    return {
      add: !has,
      remove: !!has
    };
  };

  TagPickerController.prototype.clearSearch = function() {
    this.scope.search = "";
    return this.current.parent.browse();
  };

  TagPickerController.prototype.nodeChange = function(node) {
    if (node == null) {
      return;
    }
    if (node.query == null) {
      this.scope.search = "";
    }
    if (node.id === 'search') {
      this.track('search', node.query);
    } else {
      this.track('view', node.id);
    }
    this.nodeItems = node.getItems();
    this.nodeItems.splice(0, 0, 'search');
    this.activeIndex = 0;
  };

  TagPickerController.prototype.pickTag = function(tag) {
    var realTag;
    if (this.tagSelected(tag)) {
      realTag = this.tagMap[tag.slug][tag.value];
      return this.removeTag({
        tag: realTag
      });
    } else {
      return this.addTag({
        tag: tag
      });
    }
  };

  TagPickerController.prototype.tagSelected = function(tag) {
    var ref;
    return !!((ref = this.tagMap[tag.slug]) != null ? ref[tag.value] : void 0);
  };

  TagPickerController.prototype.rebuildTagMap = function(tags) {
    var i, len, tag;
    this.tagMap = {};
    for (i = 0, len = tags.length; i < len; i++) {
      tag = tags[i];
      this.tagMap[tag.slug] = this.tagMap[tag.slug] || {};
      this.tagMap[tag.slug][tag.value] = tag;
    }
  };

  TagPickerController.prototype.keyUp = function(event) {
    var keycode;
    keycode = event.which || event.charCode || event.keyCode;
    switch (keycode) {
      case KEYS.DOWN:
        this.nextItem(event);
        break;
      case KEYS.UP:
        this.previousItem(event);
        break;
      case KEYS.LEFT:
        this.goBack(event);
        break;
      case KEYS.ENTER:
        this.selectItem(event);
        break;
      case KEYS.RIGHT:
        this.goDeeper(event);
    }
  };

  TagPickerController.prototype.keyPress = function(event) {
    var keycode;
    keycode = event.which || event.charCode || event.keyCode;
    if (this.activeItem !== 'search') {
      this.scope.search += String.fromCharCode(keycode);
      this.current.search(this.scope.search);
      event.preventDefault();
    }
  };

  TagPickerController.prototype.hoverItem = function(item) {
    var index;
    index = this.nodeItems.indexOf(item);
    if (index >= 0) {
      this.activeIndex = index;
    }
  };

  TagPickerController.prototype.nextItem = function(event) {
    this.activeIndex++;
    return event.preventDefault();
  };

  TagPickerController.prototype.previousItem = function(event) {
    this.activeIndex--;
    return event.preventDefault();
  };

  TagPickerController.prototype.selectItem = function(event) {
    var group, part, ref, ref1;
    if (typeof this.activeItem === 'string') {
      part = this.activeItem.split('_');
      part = part[part.length - 1];
      if (part === 'prev') {
        group = (ref = this.nodeItems[this.activeIndex + 1]) != null ? ref.parent : void 0;
        group.prev();
      }
      if (part === 'next') {
        group = (ref1 = this.nodeItems[this.activeIndex - 1]) != null ? ref1.parent : void 0;
        if (parent.allowPage) {
          group.next();
        } else {
          group.more();
        }
      }
    } else {
      this.activeItem.select();
    }
    return event.preventDefault();
  };

  TagPickerController.prototype.goBack = function(event) {
    var ref;
    if (this.activeItem !== 'search' || this.scope.search === "") {
      if ((ref = this.current.parent) != null) {
        if (typeof ref.browse === "function") {
          ref.browse();
        }
      }
      return event.preventDefault();
    }
  };

  TagPickerController.prototype.goDeeper = function(event) {
    if (this.activeItem === 'search') {
      return;
    }
    if (this.activeItem === 'browse') {
      this.tree.startBrowse();
      event.preventDefault();
    } else if (this.activeItem.browse != null) {
      this.activeItem.browse();
      event.preventDefault();
    }
  };

  TagPickerController.prototype.indexChanged = function() {
    if (this.activeItem === 'search') {
      this.searchBox.focus();
    } else {
      this.focuser.focus();
    }
    return this.scope.$broadcast('tagpicker:activeItemChanged', this.activeItem);
  };

  return TagPickerController;

})();


/* @ngInject */

TagPickerTreeService = function($http, $q, $timeout, ApiUrl) {
  var RootNode, SearchNode, Tag, TagGroup, TagTypeNode, Tree, TreeNode, tagPickerRootURL;
  tagPickerRootURL = ApiUrl.partial('tag');
  Tree = (function() {
    function Tree(rootTagPath, programId, skip) {
      this.rootTagPath = rootTagPath || [];
      this.programId = programId;
      this.rootUrl = tagPickerRootURL.partial.apply(tagPickerRootURL, rootTagPath);
      this.skip = skip;
      this.rootNode = new RootNode(this);
      this.currentNode = null;
      this.pickTagHandlers = [];
      this.nodeChangeHandlers = [];
    }

    Tree.prototype.getBreadcrumb = function() {
      return this.currentNode.getBreadcrumb();
    };

    Tree.prototype.queryParams = function(extra) {
      if (extra == null) {
        extra = {};
      }
      extra.program_id = this.programId;
      if (this.skip.length > 0) {
        extra.skip = this.skip;
      }
      return extra;
    };

    Tree.prototype.httpGet = function(url, params, path) {
      if (path == null) {
        path = [];
      }
      params = this.queryParams(params);
      url = this.rootUrl.apply(this, slice.call(path).concat([url]));
      return $http.get(url, {
        params: params
      }).then(function(r) {
        return r.data.items || r.data.item;
      });
    };

    Tree.prototype.httpGetAll = function(slug, params) {
      var url;
      url = tagPickerRootURL(slug, 'all');
      params = this.queryParams(params);
      return $http.get(url, {
        params: params
      }).then(function(r) {
        return r.data.items;
      });
    };

    Tree.prototype.browseTo = function(node) {
      this.currentNode = node;
      this.nodeChange(node);
    };

    Tree.prototype.startBrowse = function() {
      return this.browseTo(this.rootNode.children[0]);
    };

    Tree.prototype.pickTag = function(tag) {
      var func, i, len, ref;
      ref = this.pickTagHandlers;
      for (i = 0, len = ref.length; i < len; i++) {
        func = ref[i];
        func(tag);
      }
    };

    Tree.prototype.nodeChange = function(node) {
      var func, i, len, ref;
      ref = this.nodeChangeHandlers;
      for (i = 0, len = ref.length; i < len; i++) {
        func = ref[i];
        func(node);
      }
    };

    Tree.prototype.createHandler = function(list, handler) {
      var index;
      index = list.indexOf(handler);
      if (index === -1) {
        list.push(handler);
      }
      return (function(_this) {
        return function() {
          index = list.indexOf(handler);
          if (index >= 0) {
            list.splice(index, 1);
          }
        };
      })(this);
    };

    Tree.prototype.onPickTag = function(handler) {
      return this.createHandler(this.pickTagHandlers, handler);
    };

    Tree.prototype.onNodeChange = function(handler) {
      return this.createHandler(this.nodeChangeHandlers, handler);
    };

    Tree.prototype.dfs = function(predicate) {
      return this.rootNode.dfs(predicate);
    };

    return Tree;

  })();
  Tag = (function() {
    function Tag(data, parent) {
      this.id = data.id, this.name = data.name, this.value = data.value, this.label = data.label, this.slug = data.slug, this.description = data.description, this.tag_for = data.tag_for, this.short_name = data.short_name, this.short_label = data.short_label;
      defineParent(this, parent);
    }

    Object.defineProperties(Tag.prototype, {
      tree: {
        get: function() {
          return this.parent.tree;
        }
      }
    });

    Tag.prototype.select = function() {
      return this.tree.pickTag(this);
    };

    return Tag;

  })();
  TagGroup = (function() {
    function TagGroup(label1, slug1, tags, parent) {
      var i, len, tag;
      this.label = label1;
      this.slug = slug1;
      this.addTag = bind(this.addTag, this);
      defineParent(this, parent);
      this.tags = [];
      this.limit = 10;
      this.offset = 0;
      this.allowPage = true;
      for (i = 0, len = tags.length; i < len; i++) {
        tag = tags[i];
        this.addTag(tag);
      }
    }

    Object.defineProperties(TagGroup.prototype, {
      tree: {
        get: function() {
          return this.parent.tree;
        }
      },
      hasNextPage: {
        get: function() {
          return this.offset + this.limit < this.tags.length;
        }
      },
      hasPreviousPage: {
        get: function() {
          return this.offset > 0;
        }
      }
    });

    TagGroup.prototype.disablePaging = function() {
      this.allowPage = false;
      this.limit = 3;
    };

    TagGroup.prototype.enablePaging = function() {
      this.allowPage = true;
      this.limit = 10;
    };

    TagGroup.prototype.nextPage = function() {
      if (this.hasNextPage) {
        this.offset += this.limit;
      }
      this.parent.tree.nodeChange(this.parent);
    };

    TagGroup.prototype.previousPage = function() {
      if (this.hasPreviousPage) {
        this.offset = Math.max(0, this.offset - this.limit);
      }
      this.parent.tree.nodeChange(this.parent);
    };

    TagGroup.prototype.addTag = function(tag) {
      tag = new Tag(tag, this);
      this.tags.push(tag);
    };

    TagGroup.prototype.more = function() {
      return this.parent.viewMore(this);
    };

    return TagGroup;

  })();
  TreeNode = (function() {
    function TreeNode(parent) {
      this.select = bind(this.select, this);
      this.browse = bind(this.browse, this);
      defineParent(this, parent);
      this.tagGroups = [];
      this.tags = [];
      this.children = [];
      this.indexCounter = 0;
    }

    Object.defineProperties(TreeNode.prototype, {
      tree: {
        get: function() {
          return this.parent.tree;
        }
      },
      icon: {
        value: 'folder'
      },
      items: {
        get: function() {
          return this.children;
        }
      },
      showChildren: {
        value: true
      },
      path: {
        get: function() {
          if (this.slug != null) {
            return this.parent.path.concat(this.slug);
          } else {
            return this.parent.path;
          }
        }
      }
    });

    TreeNode.prototype.getBreadcrumb = function() {
      return this.parent.getBreadcrumb().concat(this);
    };

    TreeNode.prototype.setIndex = function(item) {
      item.index = ++this.indexCounter;
      return this.index;
    };

    TreeNode.prototype.getItems = function() {
      var end, group, i, items, len, ref, start;
      items = [];
      items.push.apply(items, this.children);
      ref = this.tagGroups;
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        if (group.allowPage && group.hasPreviousPage) {
          items.push(group.slug + "_prev");
        }
        start = group.offset;
        end = start + group.limit - 1;
        items.push.apply(items, group.tags.slice(start, +end + 1 || 9e9));
        if (group.hasNextPage) {
          items.push(group.slug + "_next");
        }
      }
      return items;
    };

    TreeNode.prototype.addTagGroup = function(data) {
      var group, i, len, ref, tag;
      group = new TagGroup(data.label, data.slug, data.tags, this);
      this.tagGroups.push(group);
      ref = group.tags;
      for (i = 0, len = ref.length; i < len; i++) {
        tag = ref[i];
        this.setIndex(tag);
      }
      return group;
    };

    TreeNode.prototype.addTag = function(tag) {
      tag = new Tag(tag);
      this.tags.append(tag);
      return tag;
    };

    TreeNode.prototype.addTagType = function(tag) {
      var node;
      node = new TagTypeNode(tag, this);
      this.setIndex(node);
      this.children.push(node);
      return node;
    };

    TreeNode.prototype.addCategory = function(cat) {
      var c, i, j, len, len1, node, ref, ref1, tag;
      node = new TreeNode(this);
      this.setIndex(node);
      node.label = cat.label;
      node.slug = cat.slug;
      node.id = 'cat-' + cat.slug;
      node.description = cat.description;
      ref = cat.categories;
      for (i = 0, len = ref.length; i < len; i++) {
        c = ref[i];
        node.addCategory(c);
      }
      ref1 = cat.tags;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        tag = ref1[j];
        node.addTagType(tag);
      }
      return this.children.push(node);
    };

    TreeNode.prototype.browse = function() {
      return this.tree.browseTo(this);
    };

    TreeNode.prototype.select = function() {
      return this.browse();
    };

    TreeNode.prototype.createSearchNode = function(query) {
      return new SearchNode(query, this);
    };

    TreeNode.prototype.disableTagPaging = function() {
      var group, i, len, ref;
      ref = this.tagGroups;
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        group.disablePaging();
      }
    };

    TreeNode.prototype.enableTagPaging = function() {
      var group, i, len, ref;
      ref = this.tagGroups;
      for (i = 0, len = ref.length; i < len; i++) {
        group = ref[i];
        group.enablePaging();
      }
    };

    TreeNode.prototype.search = function(query) {
      var searchNode;
      if (query) {
        searchNode = this.createSearchNode(query);
        return searchNode.initalize().then(function() {
          searchNode.disableTagPaging();
          searchNode.browse();
          return searchNode;
        });
      } else {
        this.browse();
        return $q.reject(this);
      }
    };

    TreeNode.prototype.dfs = function(predicate) {
      var child, child_result, i, len, ref;
      if (predicate(this)) {
        return this;
      }
      ref = this.children;
      for (i = 0, len = ref.length; i < len; i++) {
        child = ref[i];
        child_result = child.dfs(predicate);
        if (child_result) {
          return child_result;
        }
      }
      return null;
    };

    return TreeNode;

  })();
  TagTypeNode = (function(superClass) {
    extend(TagTypeNode, superClass);

    function TagTypeNode(data, parent) {
      this.label = data.label, this.full_label = data.full_label, this.full_label = data.full_label, this.slug = data.slug, this.description = data.description;
      this.id = this.slug;
      this.initalized = false;
      TagTypeNode.__super__.constructor.call(this, parent);
    }

    Object.defineProperties(TagTypeNode.prototype, {
      icon: {
        value: 'tags'
      },
      path: {
        get: function() {
          return [this.slug];
        }
      }
    });

    TagTypeNode.prototype.initalize = function() {
      this.initalized = true;
      return this.tree.httpGetAll(this.slug).then((function(_this) {
        return function(tags) {
          var group;
          group = _this.addTagGroup({
            slug: _this.slug,
            tags: tags
          });
        };
      })(this));
    };

    TagTypeNode.prototype.browse = function() {
      if (!this.initalized) {
        return this.initalize().then((function(_this) {
          return function() {
            return TagTypeNode.__super__.browse.call(_this);
          };
        })(this));
      } else {
        return TagTypeNode.__super__.browse.call(this);
      }
    };

    TagTypeNode.prototype.search = function(query) {
      return TagTypeNode.__super__.search.call(this, query).then(function(searchNode) {
        if (searchNode.tagGroups.length > 0) {
          searchNode.tagGroups[0].label = null;
          searchNode.enableTagPaging();
          searchNode.tree.nodeChange(searchNode);
        }
        return searchNode;
      });
    };

    return TagTypeNode;

  })(TreeNode);
  RootNode = (function(superClass) {
    extend(RootNode, superClass);

    function RootNode(tree) {
      var categories, common;
      RootNode.__super__.constructor.call(this, tree);
      common = this.tree.httpGet('common');
      categories = this.tree.httpGet('tree');
      this.id = 'root';
      $q.all([common, categories]).then((function(_this) {
        return function(data) {
          var cat, i, j, k, len, len1, len2, ref, ref1, ref2, tag, tags;
          ref = data[0];
          for (i = 0, len = ref.length; i < len; i++) {
            tags = ref[i];
            _this.addTagGroup(tags);
          }
          data[1].label = 'Browse Tags';
          data[1].description = "Explore all tags by category";
          ref1 = data[1].categories;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            cat = ref1[j];
            _this.addCategory(cat);
          }
          ref2 = data[1].tags;
          for (k = 0, len2 = ref2.length; k < len2; k++) {
            tag = ref2[k];
            _this.addTagType(tag);
          }
          _this.disableTagPaging();
          return _this.browse();
        };
      })(this));
    }

    Object.defineProperties(RootNode.prototype, {
      isRoot: {
        value: true
      },
      icon: {
        value: 'home'
      },
      tree: {
        get: function() {
          return this.parent;
        }
      },
      items: {
        get: function() {
          return this.tagGroups;
        }
      },
      path: {
        get: function() {
          return [];
        }
      }
    });

    RootNode.prototype.getBreadcrumb = function() {
      return [this];
    };

    RootNode.prototype.viewMore = function(tagGroup) {
      var group, node;
      node = new TreeNode(this);
      group = node.addTagGroup(tagGroup);
      group.label = null;
      node.label = tagGroup.label;
      return node.browse();
    };

    return RootNode;

  })(TreeNode);
  SearchNode = (function(superClass) {
    extend(SearchNode, superClass);

    function SearchNode(query, parent) {
      SearchNode.__super__.constructor.call(this, parent);
      this.id = 'search';
      this.query = query;
      this.label = 'Search Results';
    }

    SearchNode.prototype.initalize = function() {
      return this.tree.httpGet('search', {
        q: this.query
      }, this.path).then((function(_this) {
        return function(data) {
          var i, len, tagGroup;
          for (i = 0, len = data.length; i < len; i++) {
            tagGroup = data[i];
            _this.addTagGroup(tagGroup);
          }
          return _this;
        };
      })(this));
    };

    SearchNode.prototype.createSearchNode = function(query) {
      return new SearchNode(query, this.parent);
    };

    SearchNode.prototype.viewMore = function(tagGroup) {
      var node, slug;
      slug = tagGroup.tags[0].slug;
      node = this.tree.dfs(function(n) {
        return n.slug === slug;
      });
      return node.search(this.query).then(function(node) {
        node.tagGroups[0].label = null;
        return node;
      });
    };

    SearchNode.prototype.search = function(query) {
      return this.parent.search(query);
    };

    return SearchNode;

  })(TreeNode);
  return Tree;
};

TagList = (function() {
  function TagList(data, parent, limit) {
    var i, item, len;
    defineParent(this, parent);
    for (i = 0, len = data.length; i < len; i++) {
      item = data[i];
      defineParent(item, parent);
    }
    this.tagGroups = data;
    this.limit = limit;
  }

  return TagList;

})();

SearchNode = (function(superClass) {
  extend(SearchNode, superClass);

  function SearchNode(tags, parent) {
    SearchNode.__super__.constructor.call(this, {
      label: 'Search Results',
      tags: tags
    }, parent);
  }

  Object.defineProperties(SearchNode.prototype, {
    isRoot: {
      value: true
    },
    tagGroups: {
      get: function() {
        return this.tags;
      }
    }
  });

  return SearchNode;

})(Node);

defineParent = function(item, parent) {
  Object.defineProperty(item, 'parent', {
    value: parent,
    configurable: true
  });
};

tagPickerDirective = function() {
  return {
    restrict: 'E',
    templateUrl: 'util/tags/picker',
    scope: {
      root: '@',
      skip: '@',
      programId: '='
    },
    controller: TagPickerController,
    controllerAs: 'ctrl',
    bindToController: {
      tags: '=',
      addTag: '&',
      removeTag: '&',
      newTag: '&'
    }
  };
};

tagGroupList = function() {
  return {
    restrict: 'A',
    templateUrl: 'util/tags/groupList',
    scope: {
      group: '=dybTagGroupList'
    },
    require: '^dybTagPicker',
    link: function(scope, element, attrs, tagPicker) {
      return scope.ctrl = tagPicker;
    }
  };
};

module.directive('dybTagPicker', tagPickerDirective);

module.directive('dybTagGroupList', tagGroupList);

module.factory('TagPickerTree', TagPickerTreeService);
})(angular, angular.module("dybTags"));